import axios from './configObra/config-obra'

const defaultRoute = '/work-order-limit/'

export default {
  postQuantidadeLimite: (
    identificadorAndar,
    identificadorTorre,
    idObra,
    idInsumo,
    quantidadeLimite
  ) =>
    axios.post(`${defaultRoute}`, {
      identificadorAndar: identificadorAndar,
      identificadorTorre: identificadorTorre,
      idObra: idObra,
      idInsumo: idInsumo,
      quantidadeLimite: Number(quantidadeLimite),
    }),

  getQuantidadeLimite: (idObra) => axios.get(`${defaultRoute}${idObra}`),

  patchQuantidadeLimite: (id, quantidadeLimite) =>
    axios.patch(`${defaultRoute}${id}`, {
      quantidadeLimite: parseInt(quantidadeLimite),
    }),

  deleteQuantidadeLimite: (id) => axios.delete(`${defaultRoute}${id}`),
}
